import axios from '@/plugins/api.request'

/**
 * 列表
 * @param {*} params
 */
 export const menuList = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.setting/getMenu',
    params
  })
}